var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container breadcrum"},[_c('router-link',{staticClass:"breadcrum-firstLink",attrs:{"to":"/"}},[_vm._v("Home")]),_c('span',{staticClass:"breadcrum-slash"},[_vm._v("/")]),_vm._v(" "+_vm._s(_vm.location)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }